document.addEventListener("DOMContentLoaded", () => {

    /* ============================= */
    /* ACCORDION                    */
    /* ============================= */

    const wrapper = document.querySelector(".page-content-wrapper");
    const btn = document.querySelector(".page-content-toggle");

    if (wrapper && btn) {

        const moreText = btn.dataset.more;
        const lessText = btn.dataset.less;

        btn.addEventListener("click", () => {

            const collapsed = wrapper.dataset.collapsed === "true";

            wrapper.dataset.collapsed = !collapsed;

            btn.textContent = collapsed ? lessText : moreText;

        });

    }


    /* ============================= */
    /* STICKY ZODIAC NAV            */
    /* ============================= */

    const nav = document.querySelector(".geburtsstein-zodiac-nav");
    if(!nav) return;

    const placeholder = document.createElement("div");
    placeholder.style.height = nav.offsetHeight + "px";

    const offset = nav.offsetTop;

    window.addEventListener("scroll", () => {

        if(window.scrollY > offset){

            if(!nav.classList.contains("is-sticky")){
                nav.before(placeholder);
            }

            nav.classList.add("is-sticky");

        }else{

            nav.classList.remove("is-sticky");

            if(placeholder.parentNode){
                placeholder.remove();
            }

        }

    });

});